import React, { useEffect, useRef, useState } from 'react';
import AddProduct from '../../views/PartnerView/AddProduct';
import { useBranchContext } from '../../components/Context/BranchContext';
import { usePartnerContext } from '../../components/Context/PartnerContext';

const ProductComponent = () => {
    const { branches, FetchBranches } = useBranchContext();
    const { ProductCategory, FetchProductCategories } = usePartnerContext();
    const didFetch = useRef(false);

    useEffect(() => {
        if (!didFetch.current) {
            FetchBranches();
            FetchProductCategories();
            didFetch.current = true;
        }
    }, []);

    const isReady = Array.isArray(branches) && Array.isArray(ProductCategory);
    debugger;
    return (
        <div>
            {isReady ? <AddProduct /> : <div>Loading...</div>}
        </div>
    );
};

export default ProductComponent;
